import { render, staticRenderFns } from "./TypographyIntroTwoSection.vue?vue&type=template&id=4558c08c"
import script from "./TypographyIntroTwoSection.vue?vue&type=script&lang=ts"
export * from "./TypographyIntroTwoSection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyIntroTwoSection.vue?vue&type=style&index=0&id=4558c08c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports